import type { FieldConfig } from '../types/forms';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const PHONE_PATTERN = /^[+\d\s().-]{7,}$/;
const URL_PATTERN = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/\S*)?$/i;

export function validateField(field: FieldConfig, raw: string): string | undefined {
  const value = raw.trim();

  if (!value) {
    if (!field.required) return undefined;
    if (field.requiredMessage) return field.requiredMessage;
    if (field.type === 'select') return 'Please choose an option.';
    if (field.type === 'checkbox') return 'Please confirm to continue.';
    return 'This field is required.';
  }

  switch (field.type) {
    case 'email':
      if (!EMAIL_PATTERN.test(value)) return 'Please enter a valid email address.';
      break;
    case 'tel':
      if (!PHONE_PATTERN.test(value)) return 'Please enter a valid phone number.';
      break;
    case 'url':
      if (!URL_PATTERN.test(value)) return 'Please enter a valid URL.';
      break;
    default:
      break;
  }

  if (field.minLength && value.length < field.minLength) {
    return `Please add a little more detail (at least ${field.minLength} characters).`;
  }

  return undefined;
}
